import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || 'https://TON_PROJET.supabase.co'
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || 'TA_CLE_ANON'

const storageAdapter = {
  getItem: (key) => {
    return localStorage.getItem(key) ?? sessionStorage.getItem(key)
  },
  setItem: (key, value) => {
    const rememberMe = localStorage.getItem('sf-remember-me') === 'true'
    if (rememberMe) {
      localStorage.setItem(key, value)
    } else {
      sessionStorage.setItem(key, value)
      localStorage.removeItem(key)
    }
  },
  removeItem: (key) => {
    localStorage.removeItem(key)
    sessionStorage.removeItem(key)
  },
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storage: storageAdapter,
  }
})

// Identifiant de l'utilisateur connecté, ou null. Source de vérité pour tout ce qui doit
// correspondre à auth.uid() : chemins de stockage et colonnes propriétaire (les RLS comparent
// à auth.uid(), donc un id venu d'une prop peut être faux ou absent — c'est ce qui a produit
// des chemins « undefined/… » dans le bucket ecurie-anatomy-plates).
export async function currentUserId() {
  const { data: { session } } = await supabase.auth.getSession()
  return session && session.user ? session.user.id : null
}
